import styled from 'styled-components'
import theme from '../../../../themes/light'

const Wrapper = styled.div`
  border: solid 1px ${theme.borderColor};
  margin-top: 2rem;
`

export default Wrapper
